<template>
	<div class="flex-column">
		<div class="full-height">
			<div>
				<label class="h6 display-block">
					업무 구분
				</label>
				<label class="h6 display-block">
					업무명
					<input v-model="item.work_name" class="input-box radius-10 width-100 mt-10" placeholder="업무명을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					작업 기간

					<div class="justify-space-between gap-10 items-center mt-10">
						<input v-model="item.sDate" class="input-box radius-10  flex-1" placeholder="시작일 입력하세요" maxlength="20" lang="ko" type="date"/>
						~
						<input v-model="item.eDate" class="input-box radius-10  flex-1" placeholder="종료일 입력하세요" maxlength="20" lang="ko" type="date"/>
					</div>
				</label>

				<label class="h6 display-block mt-10">
					업무내용
					<textarea
						v-model="item.work_content"
						class="input-box radius-10 width-100 mt-10"
						placeholder="업무내용 입력하세요"
						lang="ko">
					</textarea>
				</label>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="postWork"
			>등록</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProjectWork'
	, props: ['user']
	, data: function(){
		return {
			program: {
				name: '업무 등록'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				project_uid: this.$route.params.idx
			}
		}
	}
	, methods: {
		postWork: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/postWork'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
					this.$bus.$emit('to', { name: 'ProjectView', params: this.item.project_uid})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
	}
}
</script>